import type { DefaultRootState } from 'react-redux'

import { selectEntitySetList$ } from 'syft-acp-core/reducers/generators/entities'
import { entitySetName } from 'syft-acp-core/reducers/generators/utils'

import type { AgencyJobHistoryEntry, AgencyJobsHistoryQuery } from './types'

export type AgencyJobsHistoryRequestStatus = 'idle' | 'loading' | 'failed' | 'loaded'

export const selectAgencyJobsHistory = (
  state: DefaultRootState,
  query: AgencyJobsHistoryQuery,
): AgencyJobHistoryEntry[] => selectEntitySetList$(state.agencyJobsHistory)(query)

/**
 * entityReducer records no "loaded" marker, so the status is derived: an absent set was never
 * requested, and a set's lastMessage is only set by its own failed fetch. Each query (job-wide or per
 * shift) is its own set, so one query's failure does not affect another's status.
 */
export const selectAgencyJobsHistoryStatus = (
  state: DefaultRootState,
  query: AgencyJobsHistoryQuery,
): AgencyJobsHistoryRequestStatus => {
  const entitySet = state.agencyJobsHistory.entitySets[entitySetName(query)]
  if (!entitySet) return 'idle'
  if (entitySet.isLoadingData) return 'loading'

  return entitySet.lastMessage ? 'failed' : 'loaded'
}
